import CoreInstallationPicker from "@gf-core/widgets/widgets/CoreInstallationPicker";
import { ButtonAppearance } from "../Button";
import ProfileMenu from "../ProfileMenu";
import {
  LogoLink,
  Spacer,
  SwitchButton,
  SwitcherWrapper,
  Wrapper,
} from "./TopNavigation.styles";
import { SwitchOutlined } from "@gds-react/icons";
import { useState } from "react";
import { useStore } from "../../store/store";
import { useNavigate } from "react-router";
import { routes } from "../../utils/routeHelper";
import Logo from "../Logo";

export default function TopNavigation() {
  const path = useStore.useActivePath();
  const setPath = useStore.useSetActivePath();
  const [showPicker, setShowPicker] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      <Wrapper>
        <LogoLink to="/">
          <Logo size={38} />
        </LogoLink>
        <Spacer />
        <SwitcherWrapper>
          <SwitchButton
            appearance={ButtonAppearance.primary}
            prefix={<SwitchOutlined style={{ width: 18, height: 18 }} />}
            onClick={() => setShowPicker(true)}
          >
            Switch installation
          </SwitchButton>
        </SwitcherWrapper>

        <ProfileMenu />
      </Wrapper>
      <CoreInstallationPicker
        show={showPicker}
        enableCacheClearing
        onClose={() => setShowPicker(false)}
        installationPath={path}
        onInstallationSelected={(path, accountId, installationId) => {
          setPath(path);
          setShowPicker(false);
          navigate(routes.installation.set(accountId, installationId));
        }}
      />
    </>
  );
}
